export const DropdownButtonTestAttributes = {
    popup: 'dropdown-button-popup',
    /** The check mark an option shows when it is `isSelected`. */
    selectedMark: 'dropdown-button-option-selected-mark',
};
